<template>
  <div class="mt-2 mb-2">
    <vue-friendly-iframe :src="htmlUrl()" className="friendly-iframe"></vue-friendly-iframe>
  </div>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    },
  },
  methods: {
    htmlUrl(){
      return "/api/tasks/" + this.task.id + "/show_html.json"
    }
  }
}
</script>
